export const E2E_TEST_USERS = [
	'pettertestbrukerprodous', // for e2e tests
	'petteriversenOHeb' // for e2e tests
];
